<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="internalVisible"
    :width="dialogWidth"
    :before-close="handleClose"
    append-to-body
    destroy-on-close
  >
    <!-- 内嵌一个用于展示云桌面内容的 iframe -->
    <iframe
      id="desktopSessionIframe"
      class="desktop-iframe"
      @load="onIframeLoad"
    />
  </el-dialog>
</template>

<script>
export default {
  name: 'CloudMobileDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    connectionParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 内部副本用于控制弹窗显示，避免直接修改 prop
      internalVisible: this.visible,
      dialogTitle: '阿里云手机桌面',
      session: null,
      screenWidth: window.innerWidth
    }
  },
  computed: {
    dialogWidth() {
      return this.screenWidth < 768 ? '90vw' : '440px'
    }
  },
  watch: {
    visible(newVal) {
      this.internalVisible = newVal
    },
    internalVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.destroyConnection()
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth)
    console.log('SDK:', window.Wuying.WebSDK)
    // 检查 SDK 是否加载完成，确保调用 initConnection 时已存在
    const checkSDK = () => {
      if (window.Wuying.WebSDK) {
        // SDK 已加载
      } else {
        setTimeout(checkSDK, 100)
      }
    }
    checkSDK()
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth
    },
    initConnection() {
      // 避免重复初始化
      if (this.session) return

      // 从 connectionParams 中获取参数，专用于云桌面连接
      const { ticket, desktopInfo, regionId, openType, resourceType } =
        this.connectionParams
      const userInfo = { ticket: ticket || '' }
      const sessionParam = {
        openType: openType || 'inline',
        iframeId: 'desktopSessionIframe',
        resourceType: resourceType || 'local',
        connectType: 'desktop', // 云桌面连接必须设置为 "desktop"
        userInfo,
        desktopInfo: desktopInfo || {},
        regionId: regionId || ''
      }

      const wuyingSdk = window.Wuying.WebSDK
      if (!wuyingSdk) {
        console.error('WuyingWebSDK 未加载，请检查路径')
        return
      }
      this.session = wuyingSdk.createSession('appstream', sessionParam)

      this.session.addHandle('onDisConnected', (data) => {
        console.log('云桌面断开连接：', data)
      })
      this.session.addHandle('onError', (data) => {
        console.error('连接错误：', data)
        this.$message.error('连接错误')
      })
      this.session.addHandle('onRuntimeMsg', (data) => {
        console.log('运行时消息：', data)
        this.$message.info('运行时消息：', data)
      })

      this.session.start()
    },
    onIframeLoad() {
      // 当 iframe 加载完成后，初始化连接
      this.initConnection()
    },
    destroyConnection() {
      if (this.session) {
        this.session.stop()
        this.session = null
      }
      // 清空iframe的src，避免残留的连接状态
      const iframe = document.getElementById('desktopSessionIframe')
      iframe.src = ''
    },
    handleClose(done) {
      // 关闭弹窗时更新内部状态，同时清理会话
      this.internalVisible = false
      this.destroyConnection()
      done()
    }
  }
}
</script>

<style scoped>
.desktop-iframe {
  width: 100%;
  aspect-ratio: 470 / 834;
  border: 0;
  display: block;
}
</style>
